import { RevelioTooltip } from '@revelio/ui';

import styles from './AIAssistantFAB.module.css';
import { AIAssistantSparkleDisc } from './AIAssistantSparkleDisc';

interface AIAssistantFABProps {
  onClick: () => void;
  isVisible: boolean;
  /** Fixed distance from viewport edges (px). Defaults match the classic dashboard FAB. */
  fixedBottomPx?: number;
  fixedRightPx?: number;
  tooltipLabel?: string;
  'aria-label'?: string;
  /**
   * Stacking order for the fixed FAB. Defaults to 1000 (per-dashboard /
   * per-report assistant). The global assistant passes a value below the
   * Chakra portal tier so modals overlay the AI surface.
   */
  zIndex?: number;
}

export function AIAssistantFAB({
  onClick,
  isVisible,
  fixedBottomPx = 24,
  fixedRightPx = 24,
  tooltipLabel = 'AI Assistant',
  'aria-label': ariaLabel = 'Open AI Assistant',
  zIndex = 1000,
}: AIAssistantFABProps) {
  if (!isVisible) {
    return null;
  }

  return (
    <div
      className={styles.container}
      style={{
        bottom: `${fixedBottomPx}px`,
        right: `${fixedRightPx}px`,
        zIndex,
      }}
    >
      <RevelioTooltip label={tooltipLabel} placement="left">
        <AIAssistantSparkleDisc
          as="button"
          size="36px"
          aria-label={ariaLabel}
          onClick={onClick}
          className={styles.fab}
        />
      </RevelioTooltip>
    </div>
  );
}
